import { EntDirection } from "./direction";
import { EntUnitMeasurement } from "./unitMeasurement";

export class EntTypeProduct {
  id: number = 0; 
  nameRu: string = "";
  nameKy: string = "";
  unitMeasurement: EntUnitMeasurement | null = null
  directions: EntDirection | null = null
  unitMeasurementId: number | null = null
  productCategoryId: number | null = null
  directionsId: number | null = null
  directionIds: number[] = []
}
